import httpClient from '../../api/axios-httpclient';
import SubscriberAPI from '@/api/SubscriberAPI.js';
import commonFunc from '@/common/commonFunction';

export default {
	getConfigSubscriberInfo: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url:
					SubscriberAPI.getAPIUrl() +
					`/configsubscriber/${commonFunc.getSubParamSubOnly()}/${payload.taxcode}`
			},
			false
		);
		if (res && res.Data) {
			context.commit('updateSubscriberConfig', res.Data);
			return res.Data;
		}
		return null;
	},

	updateIntructionForUse: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: SubscriberAPI.getAPIUrl() + `/updateintructionsforuse`,
			data: payload
		});
		return res && res.Success;
	},

	sendDataToMCP: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: SubscriberAPI.getAPIUrl() + `/sendatatomcp`,
			data: payload
		});
		return res && res.Success;
	},

	updateIdentificationNumberStatusForConfig: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: `${SubscriberAPI.getAPIUrl()}/updateidentificationnumberstatus/${commonFunc.getSubParamSubOnly()}/${
				payload.updateStatus
			}`
		});
		return res && res.Data;
	},

	updateCheckLicenseMeInvoice: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: `${SubscriberAPI.getAPIUrl()}/updatechecklicensemeinvoice/${commonFunc.getSubParamSubOnly()}`,
			data: payload
		});
		const updateRes = res && res.Data;
		if (updateRes) {
			context.commit('updateCheckLicenseMeInvoice', updateRes);
		}
		return updateRes;
	},

	convertIdentificationNumber: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: `${SubscriberAPI.getAPIUrl()}/convertidentificationnumber/${commonFunc.getSubParamSubOnly()}`,
			data: payload
		});
		return res && res.Data;
	},

	/**
	 * Lấy thông tin tài nguyên hóa đơn điện tử từ hệ thống MeInvoice
	 */
	getResourceMeInvoiceInfo: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: `${SubscriberAPI.getAPIUrl()}/resource-info/${commonFunc.getSubParamSubOnly()}/${
				payload.companyTaxCode
			}`
		});
		if (res && res.Data) {
			return res.Data;
		}
		return null;
	},

	/**
	 * Cập nhật trạng thái đã hiển thị popup tự động cập nhật CCTC
	 */
	updateShowedUpdateIdentificationPopup: async function(context, payload) {
		let res = await httpClient.putAsync({
			url: `${SubscriberAPI.getAPIUrl()}/updateshowedidentificationpopup/${commonFunc.getSubParamSubOnly()}`,
			data: payload || {}
		});
		if (res && res.Data) {
			context.commit('updateShowedUpdateIdentificationPopup', true);
			return true;
		}

		return false;
	}
};
